import {
  PDFDocumentProxy,
  PDFPageProxy
} from 'pdfjs-dist/types/src/display/api'
import { pdfjs } from 'react-pdf'

const configurePdfWorker = () => {
  if (!pdfjs.GlobalWorkerOptions.workerSrc) {
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`
  }
}

export const isPdfUrl = (url: string) => {
  try {
    const parsed = new URL(url, window.location.origin)
    const formatParam = parsed.searchParams.get('format')
    if (formatParam?.toLowerCase() === 'pdf') {
      return true
    }
    return parsed.pathname.toLowerCase().endsWith('.pdf')
  } catch {
    const base = url.split('?')[0].toLowerCase()
    if (url.toLowerCase().includes('format=pdf')) {
      return true
    }
    return base.endsWith('.pdf')
  }
}

export const renderPdfPageToDataUrl = async ({
  pdfUrl,
  pageNumber,
  scale
}: {
  pdfUrl: string
  pageNumber: number
  scale: number
}) => {
  configurePdfWorker()
  const pdf: PDFDocumentProxy = await pdfjs.getDocument(pdfUrl)
    .promise
  const page: PDFPageProxy = await pdf.getPage(pageNumber)
  const viewport = page.getViewport({ scale })
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  if (!context) {
    throw new Error('Canvas context not available')
  }

  canvas.height = viewport.height
  canvas.width = viewport.width

  await page.render({ canvasContext: context, viewport }).promise

  return canvas.toDataURL('image/png')
}
